<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle id="circle-1" opacity="0.6" cx="10" cy="10.8" r="9.245" fill="#1C74DA" />
    <circle id="circle-2" opacity="0.6" cx="10" cy="10.8" r="6.245" fill="#7da6e8" />
    <circle id="circle-3" opacity="0.6" cx="10" cy="10.8" r="7.245" fill="#1C74DA" />
    <g filter="url(#filter0_d_8801_24616)">
      <circle cx="10" cy="10.8" r="5.24414" fill="#1C74DA" />
    </g>
    <defs>
      <filter
        id="filter0_d_8801_24616"
        x="0"
        y="0.255859"
        width="40.4883"
        height="40.4883"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0509804 0 0 0 0 0.266667 0 0 0 0 0.568627 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8801_24616" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8801_24616"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'PlayAnimation',
}
</script>
<style>
#circle-1 {
  animation: 0.3s linear 1s infinite alternate show;
}
#circle-2 {
  animation: 0.2s linear 0.5s infinite alternate show;
  animation-delay: 0.125s;
}
#circle-3 {
  animation: 0.5s linear 1s infinite alternate show;
}
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.8;
  }
}
</style>
